export default __webpack_public_path__ + "static/wwc-image6-b2b4fcac60d953ef401f2d4a9725b755.jpg";